import { DataColumns } from '../DataColumns/DataColumns';
import GridFlag from '../../../../Core/Components/GridFlag/GridFlag';
import { MultiViewCalenderFilterCell } from 'smart-react';
import {
  GridDateCell,
  BooleanFlagFilterCell,
} from '../../../../Core/Components/Filter/FilterElements';
/**
 * Generates a list of columns for a grid.
 * @param {object} options - The options for the grid.
 * @returns {Array} - The list of grid columns.
 */
export const GridColumnsList = async ({
  editContentSlider,
  dateRangefilter,
  setDateRangeFilter,
}) => {
  return DataColumns({
    editContentSlider,
    MultiViewCalenderFilterCell,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
    GridFlag,
    BooleanFlagFilterCell,
  });
};

export default GridColumnsList;
